import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const pensionNameAtom = atom({
    default: "",
    key: ATOM_KEY.PENSION_NAME,
});

export const usePensionNameValue = () => useRecoilValue(pensionNameAtom);
export const usePensionNameState = () => useRecoilState(pensionNameAtom);
export const useSetPensionNameState = () => useSetRecoilState(pensionNameAtom);
